<template>
    <PaymentRequired v-if="showAlert" :is-bank-provided="isBankProvided" :is-vat-provided="isVatProvided"
        :show-link="true" />
    <div class="">
        <Toast />
        <Accordion v-if="isMobile" value="1">
            <AccordionPanel value="0">
                <AccordionHeader><span class="font-semibold text-lg pl-5">Filters</span></AccordionHeader>
                <AccordionContent style="background: rgb(255 255 255);">
                    <UserFilters v-model:selectedSites="selectedSites" v-model:selectedAdvertisers="selectedAdvertisers"
                        v-model:chartType="chartType" v-model:dates="dates"
                        v-model:selectedDatePreset="selectedDatePreset" :sites="sites"
                        :distinctAdvertisers="distinctAdvertisers" :chartTypes="chartTypes" :datePresets="datePresets"
                        :selectionLabel="selectionLabel" @datePresetChange="handleDatePresetChange" />
                </AccordionContent>
            </AccordionPanel>
        </Accordion>
        <UserFilters v-else v-model:selectedSites="selectedSites" v-model:selectedAdvertisers="selectedAdvertisers"
            v-model:chartType="chartType" v-model:dates="dates" v-model:selectedDatePreset="selectedDatePreset"
            :sites="sites" :distinctAdvertisers="distinctAdvertisers" :chartTypes="chartTypes"
            :datePresets="datePresets" :selectionLabel="selectionLabel" @datePresetChange="handleDatePresetChange" />
        <div class="grid gap-2 sm:gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 mt-5">
            <AdvertiserMonthlyOverview
                v-if="isMobile"
                class="order-1"
                :dataTableSource="dataTableSource"
                :selectedDatePreset="selectedDatePreset"
                :chartType="chartType"
                :siteColumnHeader="siteColumnHeader"
            />
            <!-- Card 1: Clicks, Signups, FTDs -->
            <Card class="border-1 landing-page-card cursor-pointer order-2 sm:order-1">
                <template #content>
                    <div class="grid grid-cols-3 gap-4 text-center">
                        <!-- Section 1: clicks -->
                        <div>
                            <div @click="changeMetric('clicks')" v-tooltip.bottom="'Click me'">
                                <span class="font-semibold  md:text-md md:text-lg text-gray-sub">Clicks</span>
                                <div v-if="earnings.clicks !== null" class="text-2xl font-bold"> {{ earnings.clicks || 0
                                    }}</div>
                                <div v-else class="flex justify-center items-center" style="height: 2rem;">
                                    <Skeleton class="content-center" width="4rem" height="2rem"></Skeleton>
                                </div>
                            </div>
                        </div>

                        <!-- Section 2: signups -->
                        <div>
                            <div @click="changeMetric('signups')" v-tooltip.bottom="'Click me'">
                                <span class="font-semibold text-md md:text-lg text-gray-sub">Signups</span>
                                <div v-if="earnings.signups !== null" class="text-2xl font-bold"> {{ earnings.signups ||
                                    0 }}</div>
                                <div v-else class="flex justify-center items-center" style="height: 2rem;">
                                    <Skeleton class="content-center" width="4rem" height="2rem"></Skeleton>
                                </div>
                            </div>
                        </div>

                        <!-- Section 3: FTD -->
                        <div>
                            <div @click="changeMetric('FTD')" v-tooltip.bottom="'Click me'">
                                <span class="font-semibold text-md md:text-lg text-gray-sub">FTDs</span>
                                <div v-if="earnings.FTD !== null" class="text-2xl font-bold"> {{ earnings.FTD || 0 }}
                                </div>
                                <div v-else class="flex justify-center items-center" style="height: 2rem;">
                                    <Skeleton class="content-center" width="4rem" height="2rem"></Skeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </Card>

            <!-- Card 3: Clicks, Deposits, Deposit Value -->
            <Card class="border-1 cursor-pointer landing-page-card justify-center order-2 sm:order-3">
                <template #content>
                    <div class="grid grid-cols-2 gap-4 text-center">
                        <!-- Section 1: CPAS -->
                        <div>
                            <div @click="changeMetric('CPACount')" v-tooltip.bottom="'Click me'">
                                <span class="font-semibold text-md md:text-lg text-gray-sub">CPA's</span>
                                <div v-if="earnings.CPACount !== null" class="text-2xl font-bold"> {{ earnings.CPACount || 0
                                }}</div>
                                <div v-else class="flex justify-center items-center" style="height: 2rem;">
                                    <Skeleton class="content-center" width="4rem" height="2rem"></Skeleton>
                                </div>
                            </div>
                        </div>
                        <!-- Section 2: Income -->
                        <div>
                            <div @click="changeMetric('deposits')" v-tooltip.bottom="'Click me'">
                                <span class="font-semibold text-md md:text-lg text-gray-sub">Income</span>
                                <div v-if="earnings.deposits !== null" class="text-2xl font-bold"> {{  formatCurrency(earnings.customerTotalRevenue) || 0 }}</div>
                                <div v-else class="flex justify-center items-center" style="height: 2rem;">
                                    <Skeleton class="content-center" width="4rem" height="2rem"></Skeleton>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </Card>
        </div>
        <div class="grid sm:gap-5 grid-cols-1 lg:grid-cols-2 mt-2 sm:mt-8">
            <!-- <Card class="border-1 landing-page-card  md:col-span-1">
                <template #title>
                    <h1> {{ metricLabel }} by {{ chartTypeLabel }}</h1>
                </template>
                <template #content>
                    <br />
                    <div class="flex justify-center items-center">
                        <Chart v-if="chartType === 'Advertiser' && advertisersChartData.labels.length > 0" type="pie"
                            :data="advertisersChartData" :options="chartOptions" class="w-full md:w-[25rem]" />

                        <Chart v-if="chartType === 'Site' && sitesChartData.labels.length > 0" type="pie"
                            :data="sitesChartData" :options="chartOptions" class="w-full md:w-[25rem]" />

                        <div v-if="earnings.activePlayers === null" class="flex justify-between gap-2 mt-4">
                            <Skeleton width="4rem" height="2rem"></Skeleton>
                            <Skeleton width="4rem" height="2rem"></Skeleton>
                        </div>
                    </div>
                    <div v-if="earnings.activePlayers === null" class="flex justify-center items-center ">
                        <Skeleton shape="circle" size="22rem" class="mt-4"></Skeleton>
                    </div>
                </template>
            </Card> -->
            <DailyOverview 
                :key="`daily-overview-${dates[0]?.toISOString()}-${dates[1]?.toISOString()}`"
                :userId="userId" 
                :from="dates[0]" 
                :to="dates[1]" 
                :isMobile="isMobile" 
            />

            
            <!-- <Chart v-if="earnings.activePlayers !== null" type="pie" :data="revenueChartData"
                            :options="chartOptions" class="w-full md:w-[25rem]" /> -->

            <AdvertiserMonthlyOverview
                v-if="!isMobile"
                class="order-4"
                :dataTableSource="dataTableSource"
                :selectedDatePreset="selectedDatePreset"
                :chartType="chartType"
                :siteColumnHeader="siteColumnHeader"
            />
        </div>

    </div>
</template>

<script setup>
import { ref, onMounted, reactive, watch, computed, onUnmounted, shallowRef } from "vue";
import PaymentRequired from '../Invoice/PaymentRequired.vue';
import UserFilters from './UserFilters.vue';
import { useUserStatus } from '@/utils/userStatus'; // Import the service
import EarningsService from '@/services/EarningsService';
import SitesService from '@/services/SitesService';
import RevenueCard from './Partial/RevenueCard.vue';
import LastMonthRevenueCard from './Partial/LastMonthRevenueCard.vue';
import { presets } from '@/utils/dateHelper';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useToast } from "primevue/usetoast";
import { headerStyles, getRowStyle } from '@/global/headerStyles';
import { formatCurrency, formatCurrencyWithK } from '@/utils/currencies';
import { getTotalEarnings } from '@/utils/earnings';
import AdvertiserMonthlyOverview from './Partial/AdvertiserMonthlyOverview.vue';
import DailyOverview from './Partial/DailyOverview.vue';
const toast = useToast();

const store = useStore();
const router = useRouter();
const user = computed(() => store.state.user);
const { isBankProvided, isVatProvided, showAlert } = useUserStatus(user);
const isMobile = ref(window.innerWidth <= 768);
const userId = computed(() => store.getters.userId);

//sites


const sites = ref([]);
const selectedSites = ref([]);
const lastMonthRevenue = ref(null);
//advertisers
const distinctAdvertisers = computed(() => {
    // Extract all advertiserId and advertiserName into a single array
    const allAdvertisers = totalEarnings.value.flatMap(site =>
        site.advertisers.map(advertiser => ({
            advertiserId: advertiser.advertiserId,
            advertiserName: advertiser.advertiserName
        }))
    );

    // Get distinct advertisers by creating a Set based on advertiserId
    const uniqueAdvertisers = [
        ...new Map(allAdvertisers.map(item => [item.advertiserId, item])).values()
    ];

    selectedAdvertisers.value = uniqueAdvertisers.map(advertiser => advertiser.advertiserId);
    return uniqueAdvertisers;
});

const selectedAdvertisers = ref([]);

//dates
const datePresets = shallowRef(presets);
const selectedDatePreset = ref(presets.find(preset => preset.name === 'This month'));
const dates = ref([selectedDatePreset.value.from, selectedDatePreset.value.to]);

watch(dates, async (newDate) => {
    if (newDate[1] !== null) {
        console.log('got new dates', newDate[0], newDate[1]);
        await GetEarnings(newDate[0], newDate[1]);
    }

})

watch(selectedSites, async (newSites) => {
    aggregateData();

})

watch(selectedAdvertisers, async (newAds) => {
    aggregateData();
})

const handleDatePresetChange = () => {
    dates.value = [selectedDatePreset.value.from, selectedDatePreset.value.to];
};

//earnings related
const totalEarnings = ref([]);

const earnings = reactive({
    clicks: null,
    deposits: null,
    customerTotalRevenue: null,
    customerExpectedRevenueAfterCommission: null,
    activePlayers: null,
    signups: null,
    FTD: null,
    CPACount: null,
    depositValue: null
});

function roundValues() {
    // Round the final aggregated values to 2 decimal places
    earnings.deposits = parseFloat(earnings.deposits.toFixed(2));
    earnings.customerTotalRevenue = parseFloat(earnings.customerTotalRevenue.toFixed(2));
    earnings.customerExpectedRevenueAfterCommission = parseFloat(earnings.customerExpectedRevenueAfterCommission.toFixed(2));
    earnings.clicks = parseFloat(earnings.clicks);
    earnings.depositValue = parseFloat(earnings.depositValue.toFixed(2));
}

function resetEarnings() {
    earnings.clicks = null;
    earnings.deposits = null;
    earnings.customerTotalRevenue = null;
    earnings.customerExpectedRevenueAfterCommission = null;
    earnings.activePlayers = null;
    earnings.signups = null;
    earnings.FTD = null;
    earnings.CPACount = null;
    earnings.depositValue = null;
}

function resetEarningsToZero() {
    earnings.clicks = 0;
    earnings.deposits = 0;
    earnings.customerTotalRevenue = 0;
    earnings.customerExpectedRevenueAfterCommission = 0;
    earnings.activePlayers = 0;
    earnings.signups = 0;
    earnings.FTD = 0;
    earnings.CPACount = 0;
    earnings.depositValue = 0;
}

const selectedSiteIds = computed(() => selectedSites.value.map(site => site.siteId));

function computeEarnings(siteData, advertisers, type) {
    advertisers.forEach(advertiser => {
        earnings.activePlayers += advertiser.activePlayers || 0;
        earnings.deposits += advertiser.deposits || 0;
        earnings.customerTotalRevenue += advertiser.customerTotalRevenue || 0;
        earnings.customerExpectedRevenueAfterCommission += advertiser.customerExpectedRevenueAfterCommission || 0;
        earnings.clicks += advertiser.clicks || 0;
        earnings.signups += advertiser.signups || 0;
        earnings.FTD += advertiser.FTD || 0;
        earnings.CPACount += advertiser.CPACount || 0;
        earnings.depositValue += advertiser.depositValue || 0;


        if (siteData !== null) {
            siteData.activePlayers += advertiser.activePlayers || 0;
            siteData.deposits += advertiser.deposits || 0;
            siteData.customerTotalRevenue += advertiser.customerTotalRevenue || 0;
            siteData.customerExpectedRevenueAfterCommission += advertiser.customerExpectedRevenueAfterCommission || 0;
            siteData.clicks += advertiser.clicks || 0;
            siteData.signups += advertiser.signups || 0;
            siteData.FTD += advertiser.FTD || 0;
            siteData.CPACount += advertiser.CPACount || 0;
            siteData.depositValue += advertiser.depositValue || 0;
        }

    });
    return siteData;
}

// Helper function to initialize advertiser data
function initializeAdvertiserData(advertiserId) {
    return {
        advertiserId: advertiserId,
        name: '',
        customerTotalRevenue: 0,
        customerExpectedRevenueAfterCommission: 0,
        clicks: 0,
        deposits: 0,
        activePlayers: 0,
        signups: 0,
        FTD: 0,
        CPACount: 0,
        depositValue: 0
    };
}

function aggregateDataByAdvertiser() {
    if (totalEarnings.value.length !== 0) {
        resetEarningsToZero();
        const advertiserData = {};

        // Process data from selected sites
        totalEarnings.value
            .filter(site => selectedSiteIds.value.includes(site.siteId))  // Filter by selected sites
            .forEach(site => {

                const filteredAdvertisers = site.advertisers
                    .filter(advertiser => selectedAdvertisers.value.includes(advertiser.advertiserId));  // Filter by selected advertisers

                // Aggregate advertiser data
                filteredAdvertisers.forEach(advertiser => {
                    const advertiserId = advertiser.advertiserId;
                    if (!advertiserData[advertiserId]) {
                        let newAdvertiser = initializeAdvertiserData();
                        newAdvertiser.name = advertiser.advertiserName;
                        advertiserData[advertiserId] = newAdvertiser;
                    }

                    const existingAdvertiser = advertiserData[advertiserId];

                    existingAdvertiser.customerTotalRevenue += advertiser.customerTotalRevenue || 0;
                    existingAdvertiser.customerExpectedRevenueAfterCommission += advertiser.customerExpectedRevenueAfterCommission || 0;
                    existingAdvertiser.clicks += advertiser.clicks || 0;
                    existingAdvertiser.deposits += advertiser.deposits || 0;
                    existingAdvertiser.activePlayers += advertiser.activePlayers || 0;
                    existingAdvertiser.signups += advertiser.signups || 0;
                    existingAdvertiser.FTD += advertiser.FTD || 0;
                    existingAdvertiser.CPACount += advertiser.CPACount || 0;
                    existingAdvertiser.depositValue += advertiser.depositValue || 0;
                });
            });

        // Convert object to array
        const allAdvertisers = Object.values(advertiserData);
        roundValues();

        selectedAdvertisersData.value = allAdvertisers;
        // populateRevenueChartDataByAdvertiser(allAdvertisers);
    }
}

function aggregateDataBySite() {
    if (totalEarnings.value.length !== 0) {
        resetEarningsToZero();
        const allSites = [];

        totalEarnings.value
            .filter(site => selectedSiteIds.value.includes(site.siteId))  // Filter by selected sites
            .forEach(site => {
                // Initialize site data with default values
                var siteData = {
                    siteId: site.siteId,
                    siteName: sites.value.find(s => s.siteId === site.siteId)?.siteName || 'Unknown',
                    clicks: 0,
                    deposits: 0,
                    customerTotalRevenue: 0,
                    customerExpectedRevenueAfterCommission: 0,
                    activePlayers: 0,
                    signups: 0,
                    FTD: 0,
                    CPACount: 0,
                    depositValue: 0
                };

                // Filter advertisers based on selected advertisers
                const filteredAdvertisers = site.advertisers
                    .filter(advertiser => selectedAdvertisers.value.includes(advertiser.advertiserId));  // Filter by selected advertisers

                // Compute totals for the site based on filtered advertisers
                computeEarnings(siteData, filteredAdvertisers, 'sites');

                // Add computed site data to the list
                allSites.push(siteData);
            });

        // Round values if needed
        roundValues();
        selectedSitesData.value = allSites;
        // Populate chart data for sites
        // populateRevenueChartDataBySite(allSites);
    }
}

function aggregateData() {
    aggregateDataByAdvertiser();
    aggregateDataBySite();
}


//chart section
const chartType = ref('Advertiser');
const chartTypes = ref([
    { label: 'Advertiser', value: 'Advertiser' },
    { label: store.getters.isSeo ? 'Site' : 'Toplist', value: 'Site' }
]);

const selectedSitesData = ref([]);
const selectedAdvertisersData = ref([]);

const dataTableSource = computed(() => {
    if (chartType.value === 'Site') {
        return selectedSitesData.value;
    } else if (chartType.value === 'Advertiser') {
        return selectedAdvertisersData.value;
    } else {
        return []; // Handle invalid chartType if needed
    }
});

watch(chartType, (newValue, oldValue) => {
    if (!newValue)
        chartType.value = oldValue || chartTypes.value[0].value;

    console.log(`chartType changed to ${newValue}`);
});

const advertisersChartData = ref({
    labels: [],
    datasets: [
        {
            label: '',
            data: [],
            backgroundColor: [],
            hoverBackgroundColor: []
        }
    ]
});

const sitesChartData = ref({
    labels: [],
    datasets: [
        {
            label: '',
            data: [],
            backgroundColor: [],
            hoverBackgroundColor: []
        }
    ]
});

const chartOptions = ref({
    responsive: true,
    plugins: {
        legend: {
            position: 'bottom',
        },
    },
});

const dataMetric = ref('customerTotalRevenue');

const metricLabel = computed(() => {
    const metric = availableDataMetrics.find(metric => metric.property === dataMetric.value);
    return metric ? metric.label : 'Unknown Metric';
});

const availableDataMetrics = [
    { property: 'customerTotalRevenue', label: 'My Income (€)' },
    { property: 'customerExpectedRevenueAfterCommission', label: 'Expected Income (€)' },
    { property: 'clicks', label: 'Clicks' },
    { property: 'deposits', label: 'Deposits' },
    { property: 'signups', label: 'Signups' },
    { property: 'FTD', label: 'FTDs' },
    { property: 'CPACount', label: 'CPAs' },
    { property: 'depositValue', label: 'Deposit Value' },
    { property: 'activePlayers', label: 'Active Players' }]

function changeMetric(newMetric) {
    if (earnings[newMetric] !== 0)
        dataMetric.value = newMetric;
    else
        toast.add({ severity: 'warn', summary: 'Warning', detail: 'No data to show in the chart', life: 3000 });
}

const populateRevenueChartDataByAdvertiser = computed(() => {
    const allAdvertisers = selectedAdvertisersData.value;
    const advertisers = [];
    const metrics = [];

    const validMetrics = availableDataMetrics.map(metric => metric.property);

    // Validate dataMetric
    if (!validMetrics.includes(dataMetric.value)) {
        console.warn('Invalid dataMetric value');
        return;
    }

    // Sort advertisers by the specified metric in descending order
    allAdvertisers.sort((a, b) => (b[dataMetric.value] || 0) - (a[dataMetric.value] || 0));

    // Take the top 10 advertisers
    const top10Advertisers = allAdvertisers.slice(0, 10);

    // Sum up the rest into an "Others" category
    const othersMetric = allAdvertisers.slice(10).reduce((acc, curr) => acc + (curr[dataMetric.value] || 0), 0);

    // Populate chart data
    top10Advertisers.forEach((advertiser) => {
        advertisers.push(advertiser.name);
        metrics.push(advertiser[dataMetric.value] || 0);
    });

    // Add "Others" to the chart data if applicable
    if (othersMetric > 0) {
        advertisers.push('Others');
        metrics.push(othersMetric);
    }

    return {
        labels: advertisers,
        datasets: [
            {
                label: `${metricLabel.value}`, // Capitalize metric name
                data: metrics,
                backgroundColor: generateColors(metrics.length),
                hoverBackgroundColor: generateColors(metrics.length, true),
            },
        ],
    };
});

watch(populateRevenueChartDataByAdvertiser, (newData) => {

    advertisersChartData.value = newData;
});

const populateRevenueChartDataBySite = computed(() => {
    const allSites = selectedSitesData.value;

    const siteNames = [];
    const metrics = [];

    // Sort sites by the selected metric in descending order
    allSites.sort((a, b) => (b[dataMetric.value] || 0) - (a[dataMetric.value] || 0));

    // Take the top 10 sites
    const top10Sites = allSites.slice(0, 10);

    // Sum up the rest into an "Others" category
    const othersMetric = allSites.slice(10).reduce((acc, curr) => acc + (curr[dataMetric.value] || 0), 0);

    // Populate chart data
    top10Sites.forEach((site) => {
        siteNames.push(site.siteName);
        metrics.push(site[dataMetric.value] || 0);
    });

    // Add "Others" to the chart data if applicable
    if (othersMetric > 0) {
        siteNames.push('Others');
        metrics.push(othersMetric);
    }

    // Return the chart data
    return {
        labels: siteNames,
        datasets: [
            {
                label: `${metricLabel.value}`,
                data: metrics,
                backgroundColor: generateColors(metrics.length),
                hoverBackgroundColor: generateColors(metrics.length, true),
            },
        ],
    };
});

watch(populateRevenueChartDataBySite, (newData) => {
    sitesChartData.value = newData;
});

// Utility function to generate colors for the pie chart
function generateColors(length, hover = false) {
    const colors = [
        '#42A5F5',
        '#66BB6A',
        '#FFA726',
        '#FF7043',
        '#AB47BC',
        '#26A69A',
        '#EC407A',
        '#7E57C2',
    ];
    return Array.from({ length }, (_, index) =>
        hover ? `${colors[index % colors.length]}80` : colors[index % colors.length]
    );
}

async function GetUserSites() {
    try {
        await SitesService.getUserApproved().then((response) => {
            sites.value = [...response.data];
            selectedSites.value = [...response.data];
        });
    } catch (err) {
        console.error(err);
    } finally {
    }
}

//sites should probably be passed inside the body.
async function GetEarnings(from, to) {
    resetEarnings();
    await EarningsService.getAdvertiserEarningsBySite(from ?? selectedDatePreset.value.from, to ?? selectedDatePreset.value.to, selectedSiteIds.value)
        .then((response) => {
            totalEarnings.value = response.data;
            aggregateData();
        }).catch(err => {
            console.error(err);
            resetEarningsToZero();
        });
}

onMounted(async () => {
    await GetUserSites();
    await GetEarnings();
});

//conditional labels 
const chartTypeLabel = computed(() => {
    const selectedType = chartTypes.value.find(type => type.value === chartType.value)
    return selectedType ? selectedType.label : chartType.value
})

const selectionLabel = computed(() =>
    store.getters.isSeo ? 'sites' : 'toplists'
)

const siteColumnHeader = computed(() =>
    store.getters.isSeo ? 'Site Name' : 'Toplist Name'
)

</script>

<style scoped>
/* :deep(.text-gray-sub) {
    color: #9B9BA3;
} */

/* DataTable styles including frozen columns */
.p-datatable {
    border-radius: 8px;
    overflow: hidden;
    font-family: 'ProximaNova', system-ui, -apple-system, sans-serif;
}

.p-datatable .p-datatable-thead>tr>th,
.p-datatable .p-datatable-thead>tr>th.p-frozen-column {
    background-color: #18181B;
    border-color: #18181B;
}

.p-datatable .p-datatable-tbody>tr,
.p-datatable .p-datatable-tbody>tr>td.p-frozen-column {
    background-color: #18181B;
    border-color: #18181B;
}

.p-datatable .p-datatable-tbody>tr:hover,
.p-datatable .p-datatable-tbody>tr:hover>td.p-frozen-column {
    background-color: #27272A;
}

.p-datatable .p-datatable-tbody>tr>td,
.p-datatable .p-datatable-tbody>tr>td.p-frozen-column {
    border-color: #27272A;
}

.p-accordionheader {
    padding: 5px !important;
}

.p-accordionpanel {
    border-width: 0 0 0 0;
}

@media (max-width: 768px) {
    :deep(.p-card-body) {
        padding: 10px !important;
    }
}
</style>